import {
	AfterContentInit,
	AfterViewChecked,
	AfterViewInit,
	Component,
	OnDestroy,
	OnInit,
	ViewChild,
} from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';
import { TxApiService } from '../../shared/services/txapi.service';
import { TxSession, TxUpdateStellvertreter } from '../../shared/interfaces/session';
import { TabStates, TabStateService } from '../../shared/services/tabstate.service';

import { ListOfWorkflowGroup, TxUpdateWorkflowRequest, TxWfCalendar, TxWorkflowCalendarRequest, TxWorkflowCalendarProtokoll, TxWorkflows } from '../../shared/interfaces/workflow';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { AuthService } from '../../shared/services/auth.service';
import { WorkflowService } from '../../shared/services/workflow.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map, take, tap } from 'rxjs/operators';
import { TxWorkflowCalendarComponent } from '../tx-workflow-calendar/tx-workflow-calendar.component';
import { HeartbeatService } from '../../shared/services/heartbeat.service';
import { TxTeamleiterFscDialogComponent } from './dialogs/tx-teamleiter-fsc/tx-teamleiter-fsc.dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ReportEntity } from '../../store/entities/ReportEntity';
import { TxModalPdfComponent } from '../tx-modal-pdf/tx-modal-pdf.component';
import { TxreportapiService } from '../../shared/services/txreportapi.service';
import { TxEmployeeDocumentsDialogComponent } from '../dialogs/tx-employee-documents/tx-employee-documents.dialog.component';
import moment from 'moment';
import { CalendarService } from '../../shared/services/calendar.service';
import { Store } from '@ngrx/store';
import { getReportList } from '../../store/selectors/reports.selectors';

declare let Messenger: any;

@Component({
	selector: 'tx-teamleiter',
	templateUrl: './txteamleiter.component.html',
	styleUrls: ['./txteamleiter.component.scss'],
	providers: [TabStateService],
})
export class TxTeamleiterComponent implements OnInit, OnDestroy {
	constructor(
		private myTxApiservice: TxApiService,
		private myAuthService: AuthService,
		public myTabStateService: TabStateService,
		private myWorkflowService: WorkflowService,
		private router: Router,
		private readonly reportService: TxreportapiService,
		private hearbeatService: HeartbeatService,
		public dialog: MatDialog,
		private calendarService: CalendarService,
		private store: Store,
	) {
		this.router.events.subscribe((evt) => {
			if (evt instanceof NavigationEnd && evt.url.indexOf('teamleiter') > -1) {
				// trick the Router into believing it's last link wasn't previously loaded
				this.calendar?.jumpToToday();
			}
		});
	}

	@ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
		if (mp) this.dataSource.paginator = mp;
	}

	tabState: TabStates;
	reports$: Observable<ReportEntity[]>;
	loadingReport = false;

	Workflow;
	myWorkflowCalendar: TxWfCalendar[];

	myWorkflowHasData = false;

	displayedColumns = ['datum', 'typ', 'name', 'bearbeiter', 'notiz', 'antwort', 'actions'];
	expandedColumns = ['expandedInfo'];
	dataSource = new MatTableDataSource<TxWorkflows>([]);
	myTeamleaderState = false;
	session: TxSession;
	wfGroups: Array<ListOfWorkflowGroup> = null;
	calendarReady = false;
	calendarIsBusy = false;
	workflowDataNote: {
		[key: number]: string;
	} = {};

	@ViewChild('txWorkflowCalendarComponent')
	calendar?: TxWorkflowCalendarComponent;

	@ViewChild('txTimeSumsChartComponent')
	chartComponent?: any;

	private lockWatch: {
		[key: string]: boolean;
	} = {};

	groupFilterTrigger = false;
	hasAlwaysInfoRow = () => true;

	isCalendarReady(event) {
		this.calendarReady = true;
	}

	stopPropagation(event: Event) {
		event.stopImmediatePropagation();
		event.stopPropagation();
		return false;
	}

	async downloadReport(report: ReportEntity) {
		this.loadingReport = true;

		try {
			const data = await firstValueFrom(this.reportService.getReport(report));
			this.dialog.open(TxModalPdfComponent, {
				minHeight: 'calc(100vh - 90px)',
				maxWidth: '95vw',
				height: 'auto',
				width: '1000px',
				data: {
					blob: data,
					title: report.report_name,
				},
			});
		} catch (error) {
			console.error('Error downloading report:', error);
		} finally {
			this.loadingReport = false;
		}
	}

	extractIdFromInfo(info: string): number {
		const match = info.match(/(\d+)$/);
		return match ? parseInt(match[1], 10) : 0;
	}

	openFscDialog(dataId: number, personalNr: number): void {
		const dialogRef = this.dialog.open(TxTeamleiterFscDialogComponent, {
			width: '100%',
			data: { dataId, personalNr },
		});

		dialogRef.afterClosed().subscribe((result) => {
			console.log('The dialog was closed');
			// Update the workflow calendar after dialog is closed
			this.getWorkflowCalendar();
		});
	}

	openEmployeeDocuments(item: { persnr?: number; Name?: string }, event?: Event): void {
		if (event) {
			event.preventDefault();
			event.stopPropagation();
		}

		if (!item?.persnr) {
			return;
		}

		this.dialog.open(TxEmployeeDocumentsDialogComponent, {
			width: '900px',
			maxWidth: '95vw',
			data: {
				employeeId: item.persnr,
				employeeName: item.Name,
				mode: 'teamleader',
			},
		});
	}

	updateWorkflow(aWfRow, status, notiz) {
		this.unwatchWorkflow();
		const aWfRequest: TxUpdateWorkflowRequest = new TxUpdateWorkflowRequest(aWfRow.id, status, notiz); // 100=löschen
		let apiAnfrage: Observable<TxUpdateWorkflowRequest>;
		let myResponse: any;

		apiAnfrage = this.myTxApiservice.callAPI('updateWorkflow', aWfRequest);

		apiAnfrage.subscribe(
			(mySessionData) => {
				myResponse = mySessionData;
				let responseStatus: string;
				if (myResponse.statuscode === 0) {
					responseStatus = 'success';
					this.triggerCalendarUpdate(aWfRow);
				} else {
					responseStatus = 'error';
				}
				Messenger().post({
					message: myResponse.statustext,
					type: responseStatus,
					showCloseButton: true,
					hideAfter: 5,
				});

				this.watchWorkflow();
			},
			(error) => {
				console.log('ERROR' + error);
				Messenger().post({
					message: 'ERROR' + error,
					type: 'error',
					showCloseButton: true,
				});

				this.watchWorkflow();
			}
		);
	}

	private triggerCalendarUpdate(aWfRow: any) {
		const startDate = moment(aWfRow.von).format('YYYY-MM-DD');
		const endDate = moment(aWfRow.bis || aWfRow.von).format('YYYY-MM-DD');

		setTimeout(() => {
			this.calendarService.triggerWorkflowCalendarUpdate(startDate, endDate, aWfRow.persnr);
		}, 1000);
	}

	getWorkflowCalendar(fullyear = 0) {
		this.calendarIsBusy = true;
		this.myWorkflowCalendar = null;

		// Call the workflow service method directly with teamleiter flag
		this.myWorkflowService.getWorkflowCalendar(fullyear, 1).subscribe(
			responseData => {
				this.calendarIsBusy = false;
				this.myWorkflowCalendar = responseData.WfCalendar?.map((c) =>
					Object.assign(
						{},
						{
							...c,
							ListOfDateItem: c.ListOfDateItem?.map((d) => Object.assign({}, d)) ?? [],
						}
					)
				);
			},
			error => {
				this.calendarIsBusy = false;
				console.log('ERROR' + error);
			}
		);
	}

	getWorkflow() {
		this.myWorkflowService.getWorkflow(1).subscribe(
			(response) => {
				this.Workflow = response.Workflows;
				if (this.Workflow.length > 0) {
					this.myWorkflowHasData = true;
				}
				this.refreshDataSource();
			},
			(error) => {
				console.log('ERROR' + error);
			}
		);
	}

	private refreshDataSource() {
		this.dataSource.data = [...(this.Workflow || [])];
	}

	initializeReports() {
		// Initialize reports observable using the store like other components
		this.reports$ = this.store.select(getReportList).pipe(
			map((reports) => reports.filter((report) => report.report_section === 'teamleader')),
			filter((reports) => reports.length > 0)
		);
	}

	onApproveClick(aWfRow: any, aNotiz?: string) {
		this.Workflow = this.Workflow.filter((elem) => elem !== aWfRow);
		this.updateWorkflow(aWfRow, 300, aNotiz); // 300=confirm
		this.refreshDataSource();

		this.watchWorkflow('input');
	}

	onDeclineClick(aWfRow: any, aNotiz?: string) {
		this.Workflow = this.Workflow.filter((elem) => elem !== aWfRow);
		this.updateWorkflow(aWfRow, 301, aNotiz); // 301=decline
		this.refreshDataSource();

		this.watchWorkflow('input');
	}

	checkBisData(bisData: any) {
		return bisData !== '';
	}

	toggleTeamleaderState(state: number, teamleader_for: number = 0) {
		const aUtRequest: TxUpdateStellvertreter = new TxUpdateStellvertreter(
			this.session.sessionid,
			state,
			teamleader_for
		);

		let myResponse: any;
		const apiAnfrage: Observable<TxUpdateStellvertreter> = this.myTxApiservice
			.callAPI('updateStellvertreter', aUtRequest)
			.pipe(take(1));

		apiAnfrage.subscribe(
			(myRequestData) => {
				myResponse = myRequestData;
				console.log(this.myTeamleaderState);
				if (myResponse.statuscode !== 0) {
					if (this.myTeamleaderState) {
						localStorage.setItem('teamleaderChangedTo', String(false));
					}
					Messenger().post({
						message: myResponse.statustext,
						type: 'error',
						showCloseButton: true,
					});
				} else {
					this.myTeamleaderState = !this.myTeamleaderState;
					localStorage.setItem('teamleaderChangedTo', String(this.myTeamleaderState));
				}
			},
			(error) => {
				console.log('ERROR' + error);
				Messenger().post({
					message: 'ERROR' + error,
					type: 'error',
					showCloseButton: true,
				});
			}
		);
	}

	onTabOpen(name) {
		this.myTabStateService.onTabOpen(name);
		switch (name) {
			case 't2':
				this.watchWorkflow();
				break;
		}
	}

	onTabClose(name) {
		this.myTabStateService.onTabClose(name);
		switch (name) {
			case 't2':
				this.unwatchWorkflow();
				break;
		}
	}

	onWorkflowGroupChange() {
		// Trigger chart update when workflow groups change
		this.groupFilterTrigger = !this.groupFilterTrigger;
	}

	getWorkflowGroups() {
		this.myWorkflowService.getWorkflowGroups().subscribe((data) => {
			this.wfGroups = data;
		});
	}

	ngOnInit() {
		// superseded by this.myTabStateService
		this.tabState = this.myTabStateService.getTabState();

		this.getWorkflowCalendar();
		this.getWorkflow();
		this.initializeReports();

		this.session = this.myAuthService.getSession();
		if (this.session.workflow_version === 1) {
			this.getWorkflowGroups();
		}

		if (localStorage.getItem('teamleaderChangedTo')) {
			this.myTeamleaderState = localStorage.getItem('teamleaderChangedTo') === 'true';
		} else {
			this.myTeamleaderState = Boolean(this.session.stellvertreter_aktiv);
		}

		this.router.events.subscribe((evt) => {
			if (evt instanceof NavigationEnd && evt.url.indexOf('teamleiter') > -1) {
				// trick the Router into believing it's last link wasn't previously loaded
				this.getWorkflowCalendar();
				this.getWorkflow();
			}
		});

		this.watchWorkflow();
	}

	hoverBoth($event: MouseEvent) {
		if ($event.type === 'mouseenter') {
			const prev = $event.target as Element;
			prev.previousElementSibling.classList.add('hover');
		} else {
			document.querySelectorAll('.bb-0').forEach((el) => el.classList.remove('hover'));
		}
	}

	private hasWatchLock() {
		return !!Object.entries(this.lockWatch).find((s) => s[1]);
	}

	public watchWorkflow(id?: string) {
		if (!id) {
			if (this.hasWatchLock()) {
				return;
			}
		} else if (this.lockWatch[id]) {
			this.lockWatch[id] = false;
		}
		if (this.myTabStateService.getTabState('t2')) {
			this.hearbeatService.addToHeartbeat(
				'teamleiter',
				() => {
					this.getWorkflow();
				},
				60
			);
		}
	}

	public unwatchWorkflow(id?: string) {
		if (!id) {
			if (this.hasWatchLock()) {
				return;
			}
		} else {
			this.lockWatch[id] = true;
		}

		this.hearbeatService.removeFromHeartbeat('teamleiter');
	}

	ngOnDestroy() {
		this.unwatchWorkflow();
	}
}
